import axios from 'axios'
import React, { useState } from 'react'
import { ApiConnectionString } from '../../../constants/ApiConntection'
import { useAuthContext } from '../../../hooks/useAuthContext'
import LoadingSpinner from '../../../components/LoadingSpinner'

export default function DeleteTempImgModal({imgDeleted,cancelModal}) {
    const [complete,setComplete] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
    const {user} = useAuthContext();
//styled
    const handleDelete = async () => {
        setIsLoading(true); // Start loading
        try {
            const deleteImg = await axios.delete(`${ApiConnectionString}/api/BookingProfile/ImageTemp`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            if (deleteImg.status === 200) {
                setComplete(true);
                imgDeleted();
            }
        } catch (error) {
            console.error("Error deleting image:", error); // Handle the error
        } finally {
            setIsLoading(false); // Stop loading regardless of success or failure
        }
    };

    if(isLoading){
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <LoadingSpinner />
          </div>
        </div>
      );
    }else{
        if(complete){
            return (
                <div className="send-modal-overlay">
                  <div className="send-modal">
             
                    <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Image Deleted</p></div> 
                    <p>The image was successfully deleted.</p>

                    <div className="send-modal-footer">
                      <button      className="pointer cancelButton fw-bold mx-2 px-3" onClick={cancelModal}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              );
        }else{
            return (
                <div className="send-modal-overlay">
                  <div className="send-modal">
                  <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Image</p></div> 
           

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
           <p>Please confirm that you want to delete this image.</p>
                    <div className="send-modal-footer">
                      <button className="delete-button mx-3" onClick={handleDelete}>
                        Confirm
                      </button>
                      <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>

                    </div>
                  </div>
                </div>
              );
        }
    }
    
 
    
}
